import { createFileRoute } from "@tanstack/react-router";
import { DashboardShell, PlaceholderCard } from "@/components/DashboardShell";
import { ADMIN_NAV } from "@/lib/nav";

export const Route = createFileRoute("/_authenticated/admin/properties")({
  head: () => ({
    meta: [
      { title: "Property review · Landoo Admin" },
      { name: "description", content: "Property review — Landoo admin console." },
    ],
  }),
  component: () => (
    <DashboardShell title="Property review" role="Admin" items={ADMIN_NAV}>
      <PlaceholderCard
        title="Property review"
        description="Admin queue for Property review. Actions and filters will be added here."
      />
    </DashboardShell>
  ),
});
